import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import * as ReactSpark from "react-spark";
import Media from "./../media/Media";

const { Link, Modal } = ReactSpark;

class Disclosure extends Component {
  static openInNewTab(url) {
    const win = window.open(url, "_blank");
    win.focus();
  }

  constructor(params) {
    super(params);
    this.state = {
      viewing: false
    };
  }

  handleClick(e) {
    if (window.innerWidth > 768) {
      this.toggleViewing();
    } else {
      Disclosure.openInNewTab(this.props.config.location.pdf);
    }
  }

  toggleViewing() {
    this.setState({
      viewing: !this.state.viewing
    });
  }

  render() {
    const { id, config = {}, className } = this.props;

    if (!config.location) {
      return null;
    }
    return (
      <Fragment>
        <Link
          className={`${className}`}
          style={{ cursor: "pointer" }}
          id={id}
          onClick={e => this.handleClick(e)}
          variant="inline"
        >
          {config.title}
        </Link>
        {this.state.viewing && (
          <Modal
            id="disclosureModal"
            type="info"
            show
            onClose={() => this.toggleViewing()}
            title={config.title}
            style={{ maxWidth: "70rem", maxHeight: "100%", top: "5%" }}
          >
            <Media
              src={config.location.pdf}
              isDisplayed={Boolean(config.location.pdf)}
            />
          </Modal>
        )}
      </Fragment>
    );
  }
}

Disclosure.propTypes = {
  id: PropTypes.string.isRequired
};

export default Disclosure;
